/**
 * A staff picker row's second line: card, room, lifetime winnings (#528).
 *
 * The picker searches every room the caller manages, and a card number is unique per room, not platform-wide — so the
 * same name and card can be two players at two rooms, and without the room the two rows were identical. The room comes
 * from the directory `PlayerProvider` already loads, matched without regard to case (a GUID may be spelled either way);
 * one the directory does not list — an inactive room — reads "another room" rather than nothing. The card stays: this
 * is a staff-only search (#494's decision).
 */
export function pickerSubtitle(
  player: { cardId: string; roomId: string; totalWinnings: number },
  rooms: readonly { id: string; name: string }[],
): string {
  const room = rooms.find((r) => r.id.toLowerCase() === player.roomId.toLowerCase())?.name ?? 'another room';
  return `${player.cardId} · ${room} · $${player.totalWinnings.toLocaleString()} lifetime`;
}
